import { Component, OnInit } from '@angular/core';
import { ClientaddressesService } from 'src/app/services/apiclient/clientaddresses/clientaddresses.service';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.css']
})
export class AddressesComponent implements OnInit {

  clientAddresses$: any;
  loader: boolean = true;

  constructor(
    private addressApi: ClientaddressesService,
    private tools: ToolsService
  ) { }

  ngOnInit() {

    this.tools.setPageClient("addresses");

    this.addressApi.getAddresses.subscribe(addresses => {
      if (addresses) {
        this.clientAddresses$ = addresses;
      }
    })

    this.addressApi.getClientAddresses().subscribe(addresses => {
      this.clientAddresses$ = addresses;
      this.loader = false;
    })

  }

  setAddresses(addresses: any) {
    this.clientAddresses$ = addresses;
  }

}
